import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';
import Label from '../Label';

const HourField = ({
  handleChange,
  labelText,
  placeholderText,
  width,
  value,
  name,
  isDisabled,
  onBlur,
  showSeconds,
  colon,
}) => (
  <>
    <Label htmlFor={name} hasMargin text={labelText} />
    <S.Hour
      showSeconds={showSeconds}
      colon={colon}
      name={name}
      id={name}
      value={value}
      width={width}
      onChange={handleChange}
      placeholder={placeholderText}
      disabled={isDisabled}
      onBlur={onBlur}
    />
  </>
);

export default HourField;

HourField.defaultProps = {
  defaultValue: '00:00',
  colon: ':',
  isDisabled: false,
  showSeconds: false,
  handleChange: () => {},
  onBlur: e => e,
  width: 100,
  value: '',
};

HourField.propTypes = {
  defaultValue: PropTypes.string,
  colon: PropTypes.string,
  showSeconds: PropTypes.bool,
  isDisabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onBlur: PropTypes.func,
  handleChange: PropTypes.func,
  labelText: PropTypes.string.isRequired,
  placeholderText: PropTypes.string.isRequired,
  width: PropTypes.number,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
};
